import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

export default class BulkImportArQuestions extends Component {
  state = {
    message: "",
    notification: false,
    notificationColor: "success",
    redirect: false,
    allSubjects: [],
    alltopics: [],
    allLevels: [],
    level_id: "",
    topic_id: "",
    subject_id: "",
    search: "",
    questionsArray: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllSubjects();
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllSubjects}?search=${this.state.search}&limit=1000&page=1`
      );
      this.setState({
        allSubjects: resp?.data?.data?.docs || [],
      });
    }
  };

  handleTopic = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllTopics}?subject_id=${this.state.subject_id}`
      );
      this.setState({
        alltopics: resp?.data?.data?.docs || [],
        topic_id: "",
        level_id: "",
        allLevels: [],
      });
    }
  };

  handleLevel = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllArLevels}?subject_id=${this.state.subject_id}&topic_id=${this.state.topic_id}`
      );
      this.setState({
        allLevels: resp?.data?.data?.docs || [],
        level_id: "",
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  showNotification = (message, color = "success") => {
    this.setState({
      notification: true,
      notificationColor: color,
      message,
    });

    setTimeout(() => {
      this.setState({ notification: false, message: "", notificationColor: "success" });
    }, 5000);
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      subject_id: this.state.subject_id,
      level_id: this.state.level_id,
      topic_id: this.state.topic_id,
      questionsArray: this.state.questionsArray,
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(Constants.postUrls.createArBulkImport, payload);
      this.showNotification(resp?.data?.message || "AR questions imported successfully.");
      this.setState({ loading: false });
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 2500);
    } catch (err) {
      this.setState({ loading: false });
      this.showNotification(
        err?.response?.data?.message || "Failed to import AR questions.",
        "error"
      );
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/ar-questions" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Bulk Import AR Questions
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Select Subject</InputLabel>
                    <Select
                      value={this.state.subject_id}
                      onChange={(e) =>
                        this.setState({ subject_id: e.target.value }, () => this.handleTopic())
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Subject</MenuItem>
                      {this.state.allSubjects.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.subject_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <InputLabel>Select Topic</InputLabel>
                    <Select
                      value={this.state.topic_id}
                      onChange={(e) =>
                        this.setState({ topic_id: e.target.value }, () => this.handleLevel())
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Topic</MenuItem>
                      {this.state.alltopics.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.topic_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <InputLabel>Select AR Level</InputLabel>
                    <Select
                      value={this.state.level_id}
                      onChange={(e) => this.setState({ level_id: e.target.value })}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select AR Level</MenuItem>
                      {this.state.allLevels.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.level_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={12}>
                    <InputLabel>AR Question JSON Array</InputLabel>
                    <TextField
                      multiline
                      minRows={14}
                      name="questionsArray"
                      value={this.state.questionsArray}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Importing..." : "Import AR Questions"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notificationColor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
